import { ArrowRight, Check } from 'lucide-react';

export interface ChecklistItem {
  marker: 'done' | 'next' | number;
  title: string;
  description: string;
}

function Marker({ marker }: Pick<ChecklistItem, 'marker'>) {
  if (marker === 'done') return <Check className="size-3.5" />;
  if (marker === 'next') return <ArrowRight className="size-3.5" />;
  return <span className="text-xs font-semibold">{marker}</span>;
}

export function Checklist({ items }: { items: ChecklistItem[] }) {
  return (
    <ul className="flex flex-col gap-4">
      {items.map(item => (
        <li key={item.title} className="flex gap-3">
          <span className="bg-primary/10 text-primary flex size-6 shrink-0 items-center justify-center rounded-full">
            <Marker marker={item.marker} />
          </span>
          <div>
            <strong className="text-gray-950">{item.title}</strong>
            <p className="text-muted-foreground text-sm">{item.description}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}
